import gbpData from "@/lib/googleBusinessProfiles.json";

/**
 * Google Business Profile name overrides for the Things to do feed.
 *
 * Google matches `operator.google_business_profile_name` against the exact
 * listing name on Google Maps, which often differs from the display name we
 * keep in the DB (e.g. "Blue Corner Red Sea" vs the full GBP name). The DB
 * name stays untouched; the override only applies to the feed and the
 * "Operated by" line on the listing page.
 */
const byDiveCenterId = gbpData.byDiveCenterId as Record<string, string>;
const byMerchantName = gbpData.byMerchantName as Record<string, string>;

const merchantGbpLookup = new Map<string, string>(
  Object.entries(byMerchantName).map(([name, gbpName]) => [name.trim().toLowerCase(), gbpName])
);

export function resolveGoogleBusinessProfileName(
  diveCenterId: string | null | undefined,
  merchantName: string | null | undefined
): string | undefined {
  if (diveCenterId && byDiveCenterId[diveCenterId]) return byDiveCenterId[diveCenterId];
  if (!merchantName) return undefined;
  return merchantGbpLookup.get(merchantName.trim().toLowerCase());
}
